import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { 
  AdminDictionaryService, 
  type DictionaryResponse,
  type RegionResponse, 
  type RegionCreateRequest, 
  type RegionUpdateRequest,
  type DictionaryItemCreateRequest,
  type DictionaryItemUpdateRequest,
  type ApiError 
} from '@/shared/api'

// === РЕГИОНЫ ===

export const useRegions = (includeInactive: boolean = false) => {
  return useQuery({
    queryKey: ['regions', includeInactive],
    queryFn: () => AdminDictionaryService.getRegions(includeInactive),
    staleTime: 5 * 60 * 1000, // 5 минут
  })
}

export const useCreateRegion = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: AdminDictionaryService.createRegion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] })
      toast.success('Регион успешно создан')
    },
    onError: (error: ApiError) => {
      if (!error?.alreadyToasted) {
        toast.error(error.detail || 'Ошибка при создании региона')
      }
    },
  })
}

export const useUpdateRegion = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: ({ id, request }: { id: number; request: RegionUpdateRequest }) =>
      AdminDictionaryService.updateRegion(id, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] })
      toast.success('Регион успешно обновлен')
    },
    onError: (error: ApiError) => {
      if (!error?.alreadyToasted) {
        toast.error(error.detail || 'Ошибка при обновлении региона')
      }
    },
  })
}

export const useDeleteRegion = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: AdminDictionaryService.deleteRegion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['regions'] })
      toast.success('Регион успешно удален')
    },
    onError: (error: ApiError) => {
      if (!error?.alreadyToasted) {
        toast.error(error.detail || 'Ошибка при удалении региона')
      }
    },
  })
}

// ПРИМЕЧАНИЕ: Виды деятельности и транспорта теперь в отдельных файлах:
// - useActivityTypes.ts
// - useTransportTypes.ts
